import React, { useId } from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { InputProps } from '@epoch-ui/components/Input';
import { TitleInput } from '@epoch-ui/components/TitleInput';

import { FormField, FormControl, FormMessage, FormItem } from '../../form';

export interface TitleInputFieldProps extends InputProps {
  label?: string;
}

export const TitleInputField = React.forwardRef<HTMLInputElement, TitleInputFieldProps>(
  ({ name, label, placeholder, className, ...props }, ref) => {
    const formCtx = useFormContext();
    const id = useId();
    return (
      <FormField
        control={formCtx.control}
        name={name || id}
        render={({ field, fieldState }): React.ReactElement => (
          <FormItem className={cn(className)}>
            <FormControl>
              <TitleInput
                {...props}
                {...field}
                value={field.value || ''}
                error={!!fieldState.error}
                placeholder={label || placeholder}
                ref={ref}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);
